import { TextInput, SelectInput, BooleanInput, DateTimeInput, required, useEditContext } from 'react-admin';
import { Stack, Typography } from '@mui/material';
import { ImageUploadInput } from '../../components/ImageUploadInput.jsx';
import { TiptapInput } from '../../components/TiptapInput.jsx';
import { NEWS_CATEGORIES, NEWS_STATUSES } from './List.jsx';

export const NewsForm = ({ isCreate }) => {
  const editCtx = useEditContext();
  const existingSlug = editCtx?.record?.slug;

  return (
    <Stack spacing={2} sx={{ maxWidth: 900 }}>
      <TextInput source="title" label="Title" validate={required()} fullWidth />

      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
        <SelectInput source="category" choices={NEWS_CATEGORIES} validate={required()} sx={{ minWidth: 200 }} />
        <SelectInput source="status" choices={NEWS_STATUSES} defaultValue="draft" sx={{ minWidth: 200 }} />
        <BooleanInput source="isFeatured" label="Featured on homepage" />
      </Stack>

      <TextInput
        source="slug"
        label="URL slug"
        helperText={isCreate ? 'Leave blank to auto-generate from the title' : `Public URL: /news/${existingSlug || ''}`}
        fullWidth
      />

      <ImageUploadInput source="heroImage" label="Hero image" />

      <TextInput
        source="excerpt"
        label="Excerpt (1–2 sentences)"
        multiline
        minRows={2}
        fullWidth
      />

      <Typography variant="overline" color="text.secondary">Article body</Typography>
      <TiptapInput source="body" label="" />

      <DateTimeInput
        source="publishedAt"
        label="Published at"
        helperText="Defaults to now when status flips to Published"
      />
    </Stack>
  );
};
